import { LOG_TABLES, STATIC_HEADERS } from "constants/api";
import { makeApiCall } from "@swiggy-private/js-utils";
import type { GetSwiggyHeadersResponsePayload } from "@swiggy-private/native-bridge";
import { ApiResponse } from "@swiggy-private/js-utils/dist/fetch/types";
import { isApp } from "./browser";
import { getSwiggyHeaders, getUserHeaders } from "./nativeBridgeHelper";
import { sendCustomNREvViaBlaze } from "./newrelic";

const DEFAULT_VERSION_CODE = "1095";
const DEFAULT_PL_VERSION = "88";

export const API_DEFAULT_HEADERS = {
    lat: "12.9716",
    lng: "77.5946",
    latitude: "12.9716",
    longitude: "77.5947",
    business_line_id: "BUSINESS_LINE_DINEOUT",
};

export const getAgentType = () => {
    return isApp() ? "webview" : "Swiggy-Mweb";
};

export const getDefaultApiHeaders = (swHeaders: GetSwiggyHeadersResponsePayload | undefined) => {
    return {
        ...API_DEFAULT_HEADERS,
        "agent-type": getAgentType(),
        platform: isApp() ? swHeaders?.platform : "Swiggy-Mweb",
        "version-code": isApp() ? (swHeaders?.["version-code"] ?? DEFAULT_VERSION_CODE) : DEFAULT_VERSION_CODE,
        "pl-version": isApp() ? (swHeaders?.["pl-version"] ?? DEFAULT_PL_VERSION) : DEFAULT_PL_VERSION,
    };
};
export interface IOptions extends RequestInit {
    searchParams?: Record<string, string>;
    bodyParams?: Record<string, unknown>;
}

export interface ICustomApiCall {
    _makeApiCall: typeof makeApiCall;
    apiHost: string;
    apiEndpoint: string;
    opts?: IOptions;
}
export const customApiCall = async <T>({
    _makeApiCall = makeApiCall,
    apiHost,
    apiEndpoint,
    opts,
}: ICustomApiCall): Promise<ApiResponse<T>> => {
    try {
        const swHeaders = (await getSwiggyHeaders()) as GetSwiggyHeadersResponsePayload;
        const userHeaders = getUserHeaders();
        const headers = {
            ...userHeaders,
            ...STATIC_HEADERS,
            ...getDefaultApiHeaders(swHeaders),
        } as RequestInit["headers"];

        const options: IOptions = {
            ...opts,
            headers: opts?.headers ? { ...headers, ...opts.headers } : headers,
        };

        return await _makeApiCall(
            {
                apiHost: apiHost,
                endpoint: apiEndpoint,
                options,
                bodyParams: options.bodyParams,
                searchParams: options.searchParams,
            },
            { ...swHeaders, ...getDefaultApiHeaders(swHeaders) },
            sendCustomNREvViaBlaze,
            LOG_TABLES,
        );
    } catch (error) {
        return {
            statusCode: 1,
            data: {} as unknown as T,
        };
    }
};
